import applyButton from "../assets/img/Desktop/Meteor_component_6_D.png";
import applyMobileButton from "../assets/img/Mobile/Meteor_component_4_M.png";
import gtag from "ga-gtag";

const ApplyLinkButton = ({ className }) => {
  const handleTrack = (e) => {
    e.preventDefault();
    //gtag
    gtag("event", "點擊投票", {});
    //蝙蝠
    window.bat.track("buttonClick", {
      buttonNm: "點擊報名連結",
    });
    window.open(
      "https://docs.google.com/forms/d/e/1FAIpQLSfqxnA404OvR8PQPZlXjgJR5VVP_Lzz0Y5QeNcg3C9M-VsZDA/viewform",
      "_blank"
    );
  };
  return (
    <a
      className={`cursor-pointer inline-block rounded-full hover:-translate-x-0.5 hover:-translate-y-0.5  hover:shadow-buttonHover ${
        className ? className : ""
      }`}
      href="https://docs.google.com/forms/d/e/1FAIpQLSebCFD_z9HGDJQ3xh6HM11nnqYILquhp19ilukbVWXLtGfOBg/viewform"
      onClick={handleTrack}
    >
      <img
        src={applyButton}
        alt="報名連結按鈕"
        className="w-148px hidden xl:inline-block"
      />
      <img
        src={applyMobileButton}
        alt="報名連結按鈕"
        className="w-127px inline-block xl:hidden"
      />
    </a>
  );
};

export default ApplyLinkButton;
